"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BadgeText = exports.BadgeWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Typography = require("../../../Typography");

var BadgeWrap = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      colors = _ref$theme.colors,
      cards = _ref$theme.cards,
      mediaQueries = _ref$theme.mediaQueries,
      variant = _ref.variant,
      hasBookmark = _ref.hasBookmark,
      hasLabelClick = _ref.hasLabelClick;
  var badgeMaxWidth = hasBookmark ? 'calc(100% - 98px)' : 'calc(100% - 32px)';
  return _defineProperty({
    position: 'absolute',
    top: space.base,
    left: space.base,
    padding: "".concat(space.xsmall, " ").concat(space.base),
    borderRadius: '2.2rem',
    backgroundColor: colors[cards.cardBadgeBgColor],
    maxWidth: hasBookmark ? 'calc(100% - 98px)' : 'calc(100% - 32px)',
    cursor: hasLabelClick ? 'pointer' : 'default'
  }, mediaQueries.medium, {
    padding: "".concat(space.xsmall, " ").concat(space.base),
    top: space.base,
    left: variant === 'list' ? space.base : space.base,
    maxWidth: variant === 'list' ? 'calc(100% - 32px)' : badgeMaxWidth
  });
});
exports.BadgeWrap = BadgeWrap;
var BadgeText = (0, _styled.default)(_Typography.Body)(function (_ref3) {
  var _ref4;

  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      cards = _ref3$theme.cards,
      mediaQueries = _ref3$theme.mediaQueries,
      hasLabelClick = _ref3.hasLabelClick;
  return _ref4 = {
    letterSpacing: '.2px',
    fontWeight: 'bold',
    color: colors[cards.cardBadgeColor]
  }, _defineProperty(_ref4, mediaQueries.large, {
    letterSpacing: '.4px'
  }), _defineProperty(_ref4, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
    position: 'relative',
    top: cards.cardBadgeTextTopIE
  }), _defineProperty(_ref4, '&:hover', {
    textDecoration: hasLabelClick ? 'underline' : 'none'
  }), _ref4;
});
exports.BadgeText = BadgeText;